<span class="placeholder flex-row center-start">
  <span class="favorito">
    <button
      class="item-navegacao-favorito-button"
      mat-icon-button
      (click)="btnFavoritoClick($event)"
      aria-label="Alterar favorito"
    >
      <mat-icon
        class="item-navegacao-favorito-button-icon"
        [svgIcon]="item?.favorita ? 'star' : 'star-bord'"
      ></mat-icon>
    </button>
  </span>
  <span (click)="selecionarLei($event)" class="descricao flex-column flex-1">
    <span class="titulo">{{ item?.titulo }}</span>
  </span>
</span>
